import React from 'react';
import { Rating } from 'semantic-ui-react';
import './style.css';

export const StarRating = ({ value, show }) => show && (
  <Rating
    disabled
    clearable
    size="massive"
    className="star-rating"
    icon="star"
    defaultRating={value}
    maxRating={5}
  />
);



// WEBPACK FOOTER //
// ./src/components/StarRating/StarRating.js